const img = (id) =>
  `https://images.unsplash.com/${id}?auto=format&fit=crop&w=1400&q=80`;

export const bannerImages = {
  learn: img('photo-1503676260728-1c00da094a0b'),
  intel: img('photo-1551288049-bebda4e38f71'),
  auto: img('photo-1454165804606-c3d57bc86b40'),
  ai: img('photo-1677442136019-21780ecad995'),
  stories: img('photo-1577896851231-70ef18881754'),
  platforms: img('photo-1523240795612-9a054b0db644'),
  website: img('photo-1460925895917-afdab827c52f'),
  analytics: img('photo-1551288049-bebda4e38f71'),
  mobile: img('photo-1512941937669-90a1b58e7e9c'),
  optimisation: img('photo-1552664730-d307ca884978'),
  administration: img('photo-1580582932707-520aed937b7b'),
  finance: img('photo-1554224155-6726b3ff858f'),
  learning: img('photo-1427504494785-3a9ca7044f45'),
  academics: img('photo-1509062522246-3755977927d7'),
  intelligence: img('photo-1460925895917-afdab827c52f'),
  logistics: img('photo-1566576912321-d58ddd7a6088'),
  leadership: img('photo-1522071820081-009f0129c71c'),
  enterprise: img('photo-1497366216548-37526070297c'),
  communication: img('photo-1577563908411-5077b6dc7624'),
  hr: img('photo-1521737711867-e3b973dfdcfe'),
  success: img('photo-1523050854058-8df90110c9f1'),
  cases: img('photo-1524178232363-1fbdb6e5cf5d'),
  about: img('photo-1524178232363-1fbdb6e5cf5d'),
  company: img('photo-1486406146926-c627a92ad1ab'),
  contact: img('photo-1423666639041-f56000c27a9a'),
  connect: img('photo-1596524430615-b46475ddff6e'),
  speaker: img('photo-1475721027785-f74eccf877e2'),
  career: img('photo-1521737604893-d14cc237f11d'),
  aboutTeam: img('photo-1522071820081-009f0129c71c'),
  aboutPartners: img('photo-1556761175-5973dc0f32e7'),
  aboutAwards: img('photo-1567427017947-545c5f8d16ad'),
  insights: img('photo-1504868584819-f8e8b4b6d7e3'),
  coverage: img('photo-1504711434969-e33886168f5c'),
  video: img('photo-1492691522150-7f5cc4100e0b'),
  talks: img('photo-1475721027785-f74eccf877e2'),
  blogs: img('photo-1499750310107-5fef28a66643'),
  newsletter: img('photo-1596524430615-b46475ddff6e'),
  students: img('photo-1427504494785-3a9ca7044f45'),
  educators: img('photo-1577896851231-70ef18881754'),
  articles: img('photo-1456327102063-0e1d6d3e6c8b'),
};
